// One of the overview's top objections, drilled into (DASH-01): each time a customer raised it in the last 7 days,
// who handled the call, and a link that plays the call from that moment (the playback is logged, PLAY-02).
import { Link, useParams } from "react-router";
import { fmtDateTime, fmtDuration, fmtPhone } from "../lib/format";
import { useMember } from "../app/session";
import { Card, Empty, ErrorNote, Loading, Page, useLoad } from "../app/ui";

export function Objection() {
  const { category = "" } = useParams();
  const { api, tz } = useMember();
  const { data, error, loading } = useLoad(() => api.objectionQuotes(category), [api, category]);
  const members = useLoad(() => api.members(), [api]);
  const who = (id: string | null) => members.data?.find((m) => m.id === id)?.display_name ?? "";
  const times = (n: number) => `${n} ${n === 1 ? "time" : "times"}`;

  return (
    <Page
      title={data?.label ?? "Objection"}
      sub={data
        ? `Raised ${times(data.total)} in the last 7 days${
          data.total > data.rows.length ? `; the latest ${data.rows.length} are shown` : ""
        }`
        : undefined}
      actions={<Link to="/overview">Back to overview</Link>}
    >
      <ErrorNote error={error} />
      {loading && !data && <Loading />}
      {data && (
        <Card>
          {data.rows.length === 0 && <Empty>Nobody raised this in the last 7 days.</Empty>}
          <div className="list">
            {data.rows.map((r) => (
              <div className="list-item" key={r.id}>
                <div className="row between">
                  <strong>
                    {r.lead
                      ? <Link to={`/leads/${r.lead.id}`}>{r.lead.name || fmtPhone(r.lead.phone_e164)}</Link>
                      : "A customer"}
                  </strong>
                  {r.t != null && (
                    <Link className="moment" to={`/calls/${r.recording_id}?t=${r.t}`}>
                      ▶ {fmtDuration(r.t)}
                    </Link>
                  )}
                </div>
                {r.quote && <div className="quote">“{r.quote}”</div>}
                <div className="faint">
                  {[who(r.member_id), fmtDateTime(r.created_at, tz)].filter(Boolean).join(" · ")}
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </Page>
  );
}
